export const PRACTICE_COMPARISON_RATE_METRICS = {
    bookingRate: {
        label: 'Booked / Leads',
        rateKey: 'booked_per_lead',
        formula: 'Cohort leads booked / cohort leads created',
        numerator: { key: 'booked', population: 'booked', label: 'Booked leads' },
        denominator: { key: 'leads', population: 'leads', label: 'Created leads' },
    },
    showUpRate: {
        label: 'Attended / Booked',
        rateKey: 'attended_per_booked',
        formula: 'Cohort leads attended / cohort leads booked',
        numerator: { key: 'attended', population: 'attended', label: 'Attended leads' },
        denominator: { key: 'booked', population: 'booked', label: 'Booked leads' },
    },
    conversionRate: {
        label: 'Started / Attended',
        rateKey: 'started_per_attended',
        formula: 'Cohort leads started / cohort leads attended',
        numerator: { key: 'started', population: 'started', label: 'Started leads' },
        denominator: { key: 'attended', population: 'attended', label: 'Attended leads' },
    },
    ftaRate: {
        label: 'FTA Rate',
        rateKey: 'fta',
        formula: 'Failed-to-attend consultations / resolved consultations',
        numerator: { key: 'appointment_fta', population: 'appointment_fta', label: 'FTA appointments' },
        denominator: { key: 'appointment_resolved', population: 'appointment_resolved', label: 'Resolved appointments' },
    },
    overallConversion: {
        label: 'Overall Conversion',
        rateKey: 'overall',
        formula: 'Cohort leads started / cohort leads created',
        numerator: { key: 'started', population: 'started', label: 'Started leads' },
        denominator: { key: 'leads', population: 'leads', label: 'Created leads' },
    },
};

export const formatPracticeComparisonRate = (value) => (
    Number.isFinite(value) ? `${value.toFixed(1)}%` : '—'
);

export function buildPracticeComparisonRow(item, index) {
    const comparison = item.practiceComparison;
    const counts = comparison?.counts || {};
    const rates = comparison?.rates || {};
    const rateDetails = Object.fromEntries(
        Object.entries(PRACTICE_COMPARISON_RATE_METRICS).map(([field, metric]) => [
            field,
            {
                ...metric,
                numerator: {
                    ...metric.numerator,
                    count: rates[metric.rateKey]?.numerator ?? counts[metric.numerator.key] ?? 0,
                },
                denominator: {
                    ...metric.denominator,
                    count: rates[metric.rateKey]?.denominator ?? counts[metric.denominator.key] ?? 0,
                },
                value: rates[metric.rateKey]?.value ?? null,
            },
        ])
    );

    return {
        id: item.practiceId || index,
        rank: index + 1,
        practiceName: item.practiceName || '',
        totalLeads: counts.leads ?? 0,
        bookedAppointments: counts.booked ?? 0,
        attendedConsultations: counts.attended ?? 0,
        startedTreatments: counts.started ?? 0,
        bookingRate: rates.booked_per_lead?.value ?? null,
        showUpRate: rates.attended_per_booked?.value ?? null,
        conversionRate: rates.started_per_attended?.value ?? null,
        ftaRate: rates.fta?.value ?? null,
        overallConversion: rates.overall?.value ?? null,
        rateDetails,
        practiceComparison: comparison || null,
    };
}
